<template>

    <div class="completion">
        <span :class="{'completion--completed': completed, 'completion--percentage': !completed }" v-html="display"></span>
    </div>

</template>


<script>
import { forEach, some, isObject } from 'lodash';
import { mapState } from 'vuex';

const full = '<svg width="17px" height="15px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M5.0052,9.352 C6.4192,9.324 13.4442,0 15.6582,0 C16.5592,0 16.6592,1.689 15.5472,3.389 C14.4342,5.09 4.6862,15.022 3.3032,15.022 C1.9192,15.022 0.3892,13.856 0.0762,10.152 C-0.2368,6.449 0.3742,4.627 2.7012,4.627 C4.7002,4.627 3.5912,9.379 5.0052,9.352 Z" fill="#FFFFFF"></path></g></svg>'; // ✔
const percent = ' %'; // Hair space

export default {
    name: 'CompletionPercent',

    props: {
        num: Number,
        initial: Number,
    },

    created()
    {
        // Initialize state in store:
        this.$store.commit('INIT_COMPLETION', [this.num, this.initial]);
    },

    computed: {
        display()
        {
            if (parseInt(this.completion, 10) < 100)
            {
                return this.completion + percent;
            }
            return full;
        },
        completed()
        {
            return (parseInt(this.completion, 10) >= 100);
        },

        ...mapState({
            completion(state)
            {
                return state.completions[this.num];
            },
        }),
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/completion-percent.vue